
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/playzone/event",
      function () {
        return require("private-next-pages/playzone/event/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/playzone/event"])
      });
    }
  